<template>
  <div>

    <table v-if="isRaceVisible" class="prop-table mb-1">
      <tr>
        <th>Статус</th>
        <td :class="statusClass">
          {{ race.status | raceStatusStr }}
        </td>
      </tr>
      <tr>
        <th>Создание</th>
        <td>
          {{ race.created_at | getMomentStr }}
        </td>
      </tr>
      <tr>
        <th>Закрытие</th>
        <td>
          {{ race.closed_at | getMomentStr }}
        </td>
      </tr>
      <tr>
        <th>Финиш</th>
        <td>
          {{ race.finished_at | getMomentStr }}
        </td>
      </tr>
      <tr>
        <th>Max participants</th>
        <td>
          {{ race.max_participants | getFormattedNumber }}
        </td>
      </tr>
      <tr>
        <th>Max place</th>
        <td>
          {{ race.max_place | getFormattedNumber }}
        </td>
      </tr>
      <tr>
        <th>Количество участников</th>
        <td>
          {{ race.participant_count | getFormattedNumber }}
        </td>
      </tr>
      <tr>
        <th>Score threshold</th>
        <td>
          {{ race.score_threshold | getFormattedNumber }}
        </td>
      </tr>
      <tr>
        <th>Score emul time step</th>
        <td>
          {{ race.score_emul_time_step | getDurationStr }}
        </td>
      </tr>
      <tr>
        <th>Score emul time total</th>
        <td>
          {{ race.score_emul_time_total | getDurationStr }}
        </td>
      </tr>
    </table>

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../../http-common.js';
import notifier from '../../notifier.js';

import { Race               } from '../../model/race.js';
import { getRaceStatusClass } from '../../model/race.js';

import LoadingIndicator from '../LoadingIndicator.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'DerbyRaceInfo',

  components: {
    LoadingIndicator,
  },

  props: {
    raceId: {
      type: Number,
      required: true
    },
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {?Object} */
      race: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {boolean} */
    isRaceVisible() {
      return this.isLoadedNormal && (this.race !== null);
    },

    statusClass() {
      return getRaceStatusClass(this.race.status);
    },
  },

  created() {
    this.loadRace();
  },

  methods: {
    loadRace() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const raceIdStr = this.raceId.toString();
      const url = '/derby_race/' + raceIdStr;

      HTTP.get(url)
      .then(response => {
        this.race = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },

  filters: {
    raceStatusStr: Race.getStatusName,
  },
}
</script>
